/**
 * Remove browser-resident account data before logout or account switching.
 * Query data is cleared by the caller; these stores cover drafts, grocery
 * lists, water/meal preferences, coach state, and other account-scoped data
 * that may contain ePHI. Locale and appearance preferences are retained.
 */
export function clearAccountScopedClientState(): void {
  const retainedLocalKeys = new Set([
    "plateOS_language",
    "plate-os-theme",
    "plate-os-color-scheme",
    "plate-os-voice-enabled",
    "plateOS_productTourEnabled",
    "plateOS_productTourComplete",
  ]);
  try {
    for (let i = localStorage.length - 1; i >= 0; i -= 1) {
      const key = localStorage.key(i);
      if (key && !retainedLocalKeys.has(key)) localStorage.removeItem(key);
    }
  } catch {
    // Storage may be unavailable in privacy mode; query clearing still runs.
  }
  try {
    sessionStorage.clear();
  } catch {
    // Storage may be unavailable in privacy mode.
  }
}